import React from "react";
import { Card, Row, Col } from "antd";
import styled from "styled-components";
import { SectionHeader } from "../SectionHeader";
import { HomePageContentWrapper } from "../Shared";
import Spacer from "src/components/base/Spacer";
import { Line } from "src/components/base/Line";
import { useHistory } from "react-router-dom";

const cities = [
  {
    name: "Toronto",
    bounds: {
      latMin: 43.581024,
      latMax: 43.855457,
      lngMin: -79.639219,
      lngMax: -79.115219,
    },
    neighborhoods: [
      {
        name: "Downtown",
        bounds: {
          latMin: 43.640, latMax: 43.670,
          lngMin: -79.410, lngMax: -79.370,
        },
      },
      {
        name: "Midtown",
        bounds: {
          latMin: 43.690, latMax: 43.710,
          lngMin: -79.410, lngMax: -79.380,
        },
      },
      {
        name: "North York",
        bounds: {
          latMin: 43.750, latMax: 43.800,
          lngMin: -79.470, lngMax: -79.370,
        },
      },
    ],
  },
  {
    name: "Markham",
    bounds: {
      latMin: 43.825,
      latMax: 43.900,
      lngMin: -79.380,
      lngMax: -79.300,
    },
    neighborhoods: [
      {
        name: "Unionville",
        bounds: {
          latMin: 43.860, latMax: 43.880,
          lngMin: -79.340, lngMax: -79.300,
        },
      },
      {
        name: "Thornhill",
        bounds: {
          latMin: 43.820, latMax: 43.840,
          lngMin: -79.450, lngMax: -79.400,
        },
      },
      {
        name: "Berczy",
        bounds: {
          latMin: 43.880, latMax: 43.900,
          lngMin: -79.350, lngMax: -79.320,
        },
      },
    ],
  },
  {
    name: "Richmond Hill",
    bounds: {
      latMin: 43.820,
      latMax: 43.950,
      lngMin: -79.485,
      lngMax: -79.370,
    },
    neighborhoods: [
      {
        name: "Bayview Hill",
        bounds: {
          latMin: 43.870, latMax: 43.890,
          lngMin: -79.420, lngMax: -79.390,
        },
      },
      {
        name: "Jefferson",
        bounds: {
          latMin: 43.900, latMax: 43.930,
          lngMin: -79.480, lngMax: -79.440,
        },
      },
      {
        name: "Oak Ridges",
        bounds: {
          latMin: 43.920, latMax: 43.950,
          lngMin: -79.480, lngMax: -79.420,
        },
      },
    ],
  },
  {
    name: "Vaughan",
    bounds: {
      latMin: 43.740,
      latMax: 43.880,
      lngMin: -79.610,
      lngMax: -79.480,
    },
    neighborhoods: [
      {
        name: "Maple",
        bounds: {
          latMin: 43.850, latMax: 43.870,
          lngMin: -79.540, lngMax: -79.500,
        },
      },
      {
        name: "Thornhill",
        bounds: {
          latMin: 43.800, latMax: 43.820,
          lngMin: -79.470, lngMax: -79.420,
        },
      },
      {
        name: "Woodbridge",
        bounds: {
          latMin: 43.770, latMax: 43.820,
          lngMin: -79.650, lngMax: -79.570,
        },
      },
    ],
  },
  {
    name: "Oakville",
    bounds: {
      latMin: 43.390,
      latMax: 43.500,
      lngMin: -79.740,
      lngMax: -79.630,
    },
    neighborhoods: [
      {
        name: "Bronte",
        bounds: {
          latMin: 43.390, latMax: 43.420,
          lngMin: -79.710, lngMax: -79.650,
        },
      },
      {
        name: "Glen Abbey",
        bounds: {
          latMin: 43.430, latMax: 43.460,
          lngMin: -79.720, lngMax: -79.670,
        },
      },
      {
        name: "River Oaks",
        bounds: {
          latMin: 43.460, latMax: 43.490,
          lngMin: -79.700, lngMax: -79.650,
        },
      },
    ],
  },
  {
    name: "Mississauga",
    bounds: {
      latMin: 43.480,
      latMax: 43.650,
      lngMin: -79.740,
      lngMax: -79.540,
    },
    neighborhoods: [
      {
        name: "Port Credit",
        bounds: {
          latMin: 43.550, latMax: 43.580,
          lngMin: -79.590, lngMax: -79.560,
        },
      },
      {
        name: "Erin Mills",
        bounds: {
          latMin: 43.530, latMax: 43.560,
          lngMin: -79.710, lngMax: -79.670,
        },
      },
      {
        name: "City Centre",
        bounds: {
          latMin: 43.590, latMax: 43.610,
          lngMin: -79.650, lngMax: -79.610,
        },
      },
    ],
  },
];

const LocationPinIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: 2 }}>
    <path d="M12 21C10.7369 19.9226 9.56619 18.7415 8.5 17.469C6.9 15.558 5 12.712 5 9.99999C4.99858 7.16754 6.70425 4.61338 9.32107 3.52939C11.9379 2.44539 14.9501 3.04523 16.952 5.04899C18.2685 6.3596 19.0059 8.14238 19 9.99999C19 12.712 17.1 15.558 15.5 17.469C14.4338 18.7415 13.2631 19.9226 12 21ZM12 4.99999C9.23995 5.0033 7.00331 7.23994 7 9.99999C7 11.166 7.527 13.185 10.035 16.186C10.6531 16.924 11.309 17.6297 12 18.3C12.691 17.6304 13.3472 16.9259 13.966 16.189C16.473 13.184 17 11.165 17 9.99999C16.9967 7.23994 14.7601 5.0033 12 4.99999ZM12 13C10.3431 13 9 11.6568 9 9.99999C9 8.34313 10.3431 6.99999 12 6.99999C13.6569 6.99999 15 8.34313 15 9.99999C15 10.7956 14.6839 11.5587 14.1213 12.1213C13.5587 12.6839 12.7957 13 12 13Z" fill="#151515"/>
  </svg>
);

const CityCommunitiesSection: React.FC = () => {
  const history = useHistory();

  const handleNeighborhoodClick = (city, neighborhood) => {
    const bounds = neighborhood ? neighborhood.bounds : city.bounds;
    const params = [
      `leaseOrSale=Sale`,
      `orderBy=input_date:DESC`,
      `latitude=lte:${bounds.latMax}`,
      `latitude=gte:${bounds.latMin}`,
      `longitude=lte:${bounds.lngMax}`,
      `longitude=gte:${bounds.lngMin}`,
      `clusters=15`,
    ].join("&");
    history.push(`/residential?${params}`);
  };

  return (
    <HomePageContentWrapper>
      <Line />
      <Spacer height={16} />
      <SectionHeader
        title="Our Specialized Regions"
        subtitle="Discover your dream home in the neighbourhoods we know best."
      />
      <Spacer height={16} />
      <Row gutter={[24, 24]}>
        {cities.map((city) => (
          <Col key={city.name} xs={24} sm={12} md={12} lg={8} xl={8}>
            <StyledCard>
              <MapIconWrapper>
                <LocationPinIcon /> <CityName onClick={() => handleNeighborhoodClick(city, null)} style={{ cursor: 'pointer' }}>{city.name}</CityName>
              </MapIconWrapper>
              <Spacer height={12} />
              <NeighborhoodsList>
                {city.neighborhoods.map((neigh) => (
                  <NeighborhoodTag
                    key={neigh.name}
                    onClick={() => handleNeighborhoodClick(city, neigh)}
                  >
                    {neigh.name} &nbsp;→
                  </NeighborhoodTag>
                ))}
              </NeighborhoodsList>
              <Spacer height={8} />
            </StyledCard>
          </Col>
        ))}
      </Row>
    </HomePageContentWrapper>
  );
};

const StyledCard = styled(Card)`
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 2px 8px 0 rgba(60, 80, 120, 0.07);
  border-radius: 12px;
  border: none;
  .ant-card-body {
    padding: 16px 16px 12px 16px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 120px;
  margin-bottom: 0;
  transition: box-shadow 0.2s, transform 0.2s;
  width: 100%;
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.color.manorleadGold};
`;

const MapIconWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const CityName = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.homeBody};
  ${({ theme }) => theme.styleGroup.body}
  font-size: ${(props) => props.theme.fontSize.h3}px;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-align: left;
  cursor: pointer;
`;

const NeighborhoodsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
`;

const NeighborhoodTag = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.color.blackPrimary};
  border: solid 1px black;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  text-decoration: none;
  position: relative;
  transition: box-shadow 0.25s cubic-bezier(0.4,0,0.2,1), border-color 0.25s cubic-bezier(0.4,0,0.2,1), border-width 0.25s cubic-bezier(0.4,0,0.2,1), color 0.2s, background 0.25s cubic-bezier(0.4,0,0.2,1);

  &:hover {
    background: ${({ theme }) => theme.color.manorleadGold};
    box-shadow: 0 4px 16px rgba(0,0,0,0.10);
    border-color: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.white};
  }

  &:hover:after {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
`;

export default CityCommunitiesSection;